import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import * as screenfull from 'screenfull';
import {DataManager, Visualisation, Toolbar, Chart, FilterBar, CustomDynamicView} from 'wc-visualisation';
import {downloadCsv, arrayToCsv, Table, Icon, Tooltip, pivotData, formatDate, formatNumber, pivotDataWithAggregation} from 'wc-lib';
import {format} from 'date-fns';
import { url } from 'inspector';


@Component({
  template: require('./fuel-mix.html'),
  name: 'renewable-fuel-mix',
  components: {
    'wc-tooltip': Tooltip
  }
})
export class RenewableFuelMix extends Vue {
  @Prop({
    default: () => []
  })
  totalFuelTypes: Array<any>;

  @Prop()
  renewableTotal: number;

  @Prop()
  nonRenewableTotal: number;

  formatNumber = formatNumber;

  get maxFuelPercentage() {
    let max = Math.max(...this.totalFuelTypes.map(x => x.percentage));
    return max ? max : 100;
  }
}


// WEBPACK FOOTER //
// src/views/electricity/nem/renewable-penetration/fuel-mix.ts